import { UseControllerProps } from 'react-hook-form';

export const emailRules: UseControllerProps['rules'] = {
  required: true,
  pattern: {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    message: 'Correo electrónico inválido'
  }
};
